import { Swiper } from 'swiper';

export default (elem, args) => {
  new Swiper(elem, {
    speed: 500,
    spaceBetween: 20,
    slidesPerView: 1.2,
    breakpoints: {
      830: {
        slidesPerView: 2.2,
        spaceBetween: 40,
      },
      1250: {
        slidesPerView: 3.2,
        spaceBetween: 30,
      },
    }
  });
}